import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NzNotificationService } from "ng-zorro-antd/notification";

@Injectable({ providedIn: 'root' })
export class ToastService {

    constructor(
        private readonly notification: NzNotificationService,
        private readonly translate: TranslateService,
    ) {

    }


    public createErrorNotification(title: string, message: string): void {
        const options = { nzClass: 'error-notification' };
        this.notification.error(
            title ? this.translate.instant(title) : '',
            message ? this.translate.instant(message) : '',
            options
        );
    }

    public createSuccessNotification(title: string, message: string): void {
        const options = { nzClass: 'success-notification' };
        this.notification.success(
            title ? this.translate.instant(title) : '',
            message ? this.translate.instant(message) : '',
            options
        );
    }

    public createInformationNotification(title: string, message: string): void {
        const options = { nzClass: 'information-notification' };
        this.notification.info(
            title ? this.translate.instant(title) : title,
            message ? this.translate.instant(message) : '',
            options
        );
    }

    public createWarningNotification(title: string, message: string): void {
        const options = { nzClass: 'warning-notification' };
        this.notification.warning(
            title ? this.translate.instant(title) : '',
            message ? this.translate.instant(message) : '',
            options
        );
    }

}